module.exports = __webpack_public_path__ + "img/img_slogan_drawfee.aee70729.png";